import { useQuery } from '@tanstack/react-query';
import { api } from '../../libs/axios';
import { MetaPagination, Fatura } from '../../utils/interfaces';

export interface FaturaFilter {
  status?: string;
  empresa?: string;
  usuario?: string;
  data_inicial?: string;
  data_final?: string;
}

export interface useFaturaProps {
  page: number;
  filter?: FaturaFilter;
}

interface GetFaturaResponse {
  pedidos: Fatura[];
  meta: MetaPagination;
}
async function getFatura({ page, filter }: useFaturaProps): Promise<GetFaturaResponse> {
  const response = await api
    .get('faturas', {
      params: {
        page,
        ...filter,
      },
    })
    .then((res) => res.data);

  const pedidos: Fatura[] = response.data;

  const meta = {
    current_page: response.meta.current_page,
    last_page: response.meta.last_page,
    per_page: response.meta.per_page,
    to: response.meta.to,
    total: response.meta.total,
  };

  return {
    pedidos,
    meta
  };
}

export function useFaturas({ page }: useFaturaProps) {
  return useQuery({
    queryKey: ['faturas', { page }],
    queryFn: () => getFatura({ page }),
    staleTime: 1,
    gcTime: 1,
    retry: false,
    refetchOnWindowFocus: false, // Only refetch when the window is not in focus
  });
}